<script>
  import './style.scss';
  import template from './template.html';
  import { CommentIcon, MenuIcon, FileIcon, ReceiptIcon, MessageTextIcon, AlertIcon, ChevronDownIcon  } from '../../icons.js';
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  import ClickOutside from 'vue-click-outside';
  import {isEmpty, keyBy} from 'lodash';

  const getterSetterDeliveryOptionValue = (paramName) => {
    return {
      get () {
        return this.coStore.deliveryOptions[paramName];
      },

      set (value) {
        this.setDeliveryOption({ option: paramName, value })
      }
    }
  };

  export default {
    template,

    props: {

      deliveryOptions: Object,
      deliveryOptionsUrl: String,
      order: Object,
      accountId: Number,
      orderOptions: Object
    },

    watch: {

      async order (order) {
        let accountId = this.coStore.onBehalf.behalf_account;
        let currentAccountId = accountId || this.accountId;
        this.getAutomatedEmailsEnabled(currentAccountId).then(result => {
          this.emailAutomationsEnabled = result.data.isEnabled;
        })

        //get user settings for delivery options
        const options = await this.getDeliveryOptions();
        let { emails, order_prefs, account_emails } = options;

        this.deliveryOptionEmails = emails;
        this.orderPrefs = order_prefs;
        this.accountEmails = account_emails;
        this.emails_to_notify = order_prefs.order_email_recipients.split(',');

        //if the user has already set emails to notify
        if (this.order && this.order?.selected_email_recipients?.length) {
          this.emails_to_notify = this.order.selected_email_recipients;
        }

        this.getEmailAutomations(currentAccountId).then(result => {
          this.automationEmails = result.data;
        })

        if (window.backend.defaultEmailRecipients) {
          this.emails_to_notify = this.emails_to_notify.concat(window.backend.defaultEmailRecipients.split(','));
        }

        //set user pereference values for delivery options
        if (!isEmpty(this.orderPrefs)) {
          for(let option in this.orderPrefs) {
            let value = this.orderPrefs[option];

            if (this.coStore.deliveryOptions.hasOwnProperty(option)) {
              this.updateDeliveryOption({ option, value });
            }
          }
        }
      },

      orderType (newValue, oldValue) {
        if (this.emailAutomationsEnabled) {
          this.addAutomatedEmailsByLanguage(this.accountTargetLanguages);
        }
      },

      accountTargetLanguages (newValue, oldValue) {
        if (this.emailAutomationsEnabled) {
          this.addAutomatedEmailsByLanguage(newValue);
        }
      }
    },

    beforeMount () {

      //set if we are using automated emails feature
      this.getAutomatedEmailsEnabled(this.accountId).then(result => {
        this.emailAutomationsEnabled = result.data.isEnabled;
      })

      //get user settings for delivery options
      this.getDeliveryOptions()
        .then((options) => {
          let { emails, order_prefs, account_emails } = options;

          this.deliveryOptionEmails = emails;
          this.orderPrefs = order_prefs;
          this.accountEmails = account_emails;
          this.emails_to_notify = order_prefs.order_email_recipients.split(',');

          //if the user has already set emails to notify
          if (this.order && this.order?.selected_email_recipients?.length) {
            this.emails_to_notify = this.order.selected_email_recipients;
          }
        });

        this.getEmailAutomations(this.accountId).then(result => {
          console.log('automations', result);

          this.automationEmails = result.data;
        })
    },

    mounted () {
      if (window.backend.defaultEmailRecipients) {
        this.emails_to_notify = this.emails_to_notify.concat(window.backend.defaultEmailRecipients.split(','));
      }
    },

    created () {
      //set user pereference values for delivery options
      if (!isEmpty(this.deliveryOptions)) {

        for(let option in this.deliveryOptions) {
          let value = this.deliveryOptions[option];

          if (this.coStore.deliveryOptions.hasOwnProperty(option)) {
            this.updateDeliveryOption({ option, value });
          }
        }
      }
    },

    computed: {

      ...mapState({
        coStore: state => state.CreateOrderStore,
      }),

      ...mapGetters('ConnectorTilesStore', [
        'nameOfActiveConnectors',
      ]),

      ...mapGetters('CreateOrderStore', [
        'deliveryOptionComment',
        'accountTargetLanguages',
        'orderType'
      ]),

      notify_on_order_submit: getterSetterDeliveryOptionValue('notify_on_order_submit'),
      notify_on_new_comment: getterSetterDeliveryOptionValue('notify_on_new_comment'),
      notify_on_order_complete: getterSetterDeliveryOptionValue('notify_on_order_complete'),
      emails_to_notify: getterSetterDeliveryOptionValue('emails_to_notify'),
      connector_delivery_method: getterSetterDeliveryOptionValue('connector_delivery_method'),
      comment: getterSetterDeliveryOptionValue('comment'),
    },

    methods: {
      ...mapActions('CreateOrderStore', [
        'onNotifyEmail',
        'updatecomment',
        'updateDeliveryOption',
        'getEmailAutomations',
        'getAutomatedEmailsEnabled',
      ]),

      ...mapMutations('CreateOrderStore', [
        'setDeliveryOption',
      ]),

      /**
       * Add automated emails based on target languages selected
       *
       * @param Array targetLanguages - [[code, description, ...]]
       */
      addAutomatedEmailsByLanguage (targetLanguages) {
        if (!targetLanguages) return;

        let orderType = this.order.types.find(type => type.plunetid == this.orderType);

        if (!orderType) return console.log('no order type found');

        let defaultEmails =this.orderPrefs.order_email_recipients.split(',');

        orderType = orderType.name.toLowerCase().trim();

          //set automated emails
          targetLanguages = targetLanguages.map(lang => lang.description);
          let automatedEmailAddresses = [];

          this.automationEmails.forEach(emailObj => {
            let language = emailObj.language;

            if (targetLanguages.includes(language) && orderType == emailObj.type.toLowerCase().trim()) {
              console.log('concating these emails', emailObj.emails)
              automatedEmailAddresses = automatedEmailAddresses.concat(emailObj.emails);
            }
          });

          this.emails_to_notify = defaultEmails.concat(automatedEmailAddresses);

          //remove duplicates
          this.emails_to_notify = [ ...new Set(this.emails_to_notify) ];
      },

      /**
      * Get dropdown/select options values for
      * Order details
      *
      */
      getDeliveryOptions () {
        return axios
          .get(this.deliveryOptionsUrl)
          .then((result) => result.data);
      },
    },

    data () {

      let selected = Object.assign({}, this.selected);

      return {
        emailAutomationsEnabled: false,
        isVisible: false,
        orderPrefs: {},
        deliveryOptionEmails: [],
        accountEmails: [],
        selectedItem: selected,
        editorText: '',
        automationEmails: {},
      }
    },

    components: {
      CommentIcon,
      MenuIcon,
      FileIcon,
      ReceiptIcon,
      MessageTextIcon,
      AlertIcon,
      ChevronDownIcon,
    },

    directives: {
      ClickOutside
    }
  }
</script>
